<div id="homepageid" class="cpcontent" style="max-width:1100px">
    <h2>SensorSim: The Exposure and Sensor Simulator for HAZMAT Field Exercises</h2>
    Complete your field training exercises with handheld chemical and radiological exposure sensors that interact realistically with mock hazards: 
    <br><br>
    <div class="row">
        <div class="col-md-8">
            <ul>
                <li>Learners perfect their hazard detection and classification skills.  </li>
                <li>Exposure readings on the handheld sensor update in real-time as learner moves among mock hazards.</li>
                <li>Easy to add to your existing indoor and outdoor exercises.  </li>
                <li>Any cell phone or tablet can serve as a handheld sensor, including learner and instructor personal mobile devices (BYOD).</li>
                <li>Easily configurable sensors and hazards, including leaks, spills, downwind plumes, and contaminated bodies of water.</li>
                <li>No limit on the number of trainees, hazards or handheld sensors in a training exercise.</li>
                <li>Instructors can focus on assessment (not dictating exposure levels from the sidelines).</li>
                <li>Instructors see on their mobile device what the learners see on their sensors, and receive post-exercise training reports.</li>
                <li>Developed with the Rutgers Center for Public Health Workforce Development, the Environmental Management Institute at Ivy Tech, the National Institute of Environmental Health Sciences, and the National Institute for Occupational Safety and Health</li>
            </ul>
        </div>
        <div class="col-md-4">

            <img src="../../assets/Home1.jpg" alt="Homepage" style="width:100%"/>
        </div>
    </div>
    If you like to learn more on how to use the application download our 
    <a href="../../assets/SensorSimQuickStart23-02-15.pdf">PDF guide</a>.
    <br><br> 

    <!-- <b>Welcome to Cell Podium's Sensor Simulator Application</b><br>
    This application simulates a chemical sensor. It is used in hazardous material training.
    <br>
    The simulated spill can be defined by either GPS coordinates of by placing bluetooth beacons on or near props.
    Cell Podium was arwarded a Phase I and II SBIR grant (1R43OH012129-01 and R44OH012129-01-00.) to fund the development of the application.
    -->
    <!--
    <div class="row" style="padding:50px"> 
        <div class="col-md-6">
            <h5>GPS based Sensor Simulator</h5>
            Every mobile phone has access to the GPS data.
            The graph below shows a walk with a mobile phone where the gps location was recorded.
            The concentric rings indicate a scenario that was set up by the teacher before.
            The individual dots show the path of the walk.
            The color indicates the conversion of the location to a hight according to the concentric rings.
            <br><br>
            <img src="../../assets/gpsmapnewark.png" style="width:100%" />
            <br><br>
            The student uses a mobile phone to display a simulated sensor reading (see pictures below).
            To invoke the screen the user enters a URL on the browser of the mobile phone.
            In this example the URL is :<br>
            <b>https://gpsfront-dev.cellpodium2.com/#/simulation</b><br>
            The student enters the scenario id as given by the teacher.
            No username and password is required.
            <br><br>
            <div class="row">
                <div class="col-md-6"><img src="../../assets/gpsmobile0.png" style="width:100%" />
                </div>
                <div class="col-md-6"><img src="../../assets/gpsmobile.png" style="width:100%" />
                </div>
            </div>
            <br><br>
            If the mobile phone has a QR-Scanner the teacher can provide a QR-code (see teacher's section below).
            <br><br>
            <img src="../../assets/qrcode.png" style="width:100%" />

            <br><br>
            A teacher can use an existing scenario or set up a scenario for his/her field exercise.
            <img src="../../assets/scenariolist.png" style="width:100%" />
            <br><br>
            <img src="../../assets/scenarioedit.png" style="width:100%" />
            <br><br>
            <img src="../../assets/scenariosensor.png" style="width:100%" />
            <br><br>
            Instructions on how to setup and change a scenario can be found on the scenario edit page itself (info button).


        </div>
        <div class="col-md-6">
            <h5>Bluetooth Beacon based Sensor Simulator</h5>
            You can download the Sensor Sim application to your Android or IOS phone using the QR-codes below.
            <br><br>
            <img src="../../assets/qrcodeandroid.jpeg" style="max-width:250px"><br>
            <b>QR code to  Android Play Store</b><br>
            <img src="../../assets/qr-codeIOS.png" style="max-width:250px"><br>
            <b>QR code to IOS Play Store</b>
            <br><br>
            In a typical field exercise during hazmat training students have to identify chemical spills.
            With Cell Podium's sensor simulator application any mobile phone can be used to display a sensor reading
            when the student is getting close to a bluetooth beacon (small maroon brick in picture below).
            <br><br>
            <img src="../../assets/Beacon.png" style="width:100%" />
            <br><br>
            Bluetooth beacons are small devices that send a small bluetooth signal out at regular intervals.
            A mobile phone can pick up this signal and read the unique id of the beacon.
            <br><br>
            <img src="../../assets/beacons/FeazyBeaconWPWhite.jpg" style="width:100%" />
            <br><br>
            The mobile application communicates with a database to find the conversion factors to convert the distance between
            the mobile phone and the bluetooth beacon into a simulated sensor value.
            <br><br>
            <img src="../../assets/gpsmobile.png" style="width:100%" />
            <br><br>
            <h5>Instructions</h5>
            The teacher sets up the displayed sensors in the scenario in the application.
            <img src="../../assets/scenariolist.png" style="width:100%" />
            <br><br>
            <img src="../../assets/scenarioedit.png" style="width:100%" />
            <br><br>
            In this case the tab "beacon" will configure the beacons. 
            The tab has instructions how to set up sensors for beacons.
            <img src="../../assets/scenariobeacon.png" style="width:100%" />
            <br><br>
            The student downloads the sensor simulator app from the google play store.
            <br><br>
            <img src="../../assets/playstore.png" style="width:100%" />
            <br><br>
            Starting the application the student enters the scenarioid as provided by the teacher.
            The application will then display sensor readings.
            <br><br>
            <div class="row">
                <div class="col-md-6"><img src="../../assets/gpsmobile0.png" style="width:100%" />
                </div>
                <div class="col-md-6"><img src="../../assets/gpsmobile.png" style="width:100%" />
                </div>
            </div>
            <br>
            <app-rssitodist></app-rssitodist>
        </div>
    </div> -->


</div>